export const urlHome = '/general/seo/main';
export const urlAbout = '/general/seo/about';
export const urlCareer = '/general/seo/career';
export const urlContacts = '/general/seo/contacts';
export const urlDelivery = '/general/seo/delivery';
export const urlFavorites = '/general/seo/favorites';
export const urlArticles = '/general/seo/articles';
export const urlReview = '/general/seo/review';
export const urlArticle = '/general/seo/newmorning';
export const urlFaq = '/general/seo/faq';
export const urlFeedbacks = '/general/seo/feedbacks';
export const urlWantToOrder = '/general/seo/want-to-order';
export const urlPartners = '/general/seo/partners';
export const urlGallery = '/general/seo/gallery';
export const urlLogistics = '/general/seo/logistics';
export const urlAccount = '/general/seo/account';
export const urlOrderHistory = '/general/seo/order-history';
export const urlVideoReviews = '/general/seo/video-reviews';
export const urlProductLists = '/general/seo/personalised-products';
export const urlArticlesArticle = slug => `/general/seo/article?article_slug=${slug}`;
export const urlProduct = slug => `/general/seo/article?product_slug=${slug}`;
export const urlCategory = slug => `/general/seo/article?category_slug=${slug}`;

export default $axios => ({});
